module.exports = function () {
    $(document).ready(function() {
        // Create canned responses options
        var createOptions = function(state, type, typeName) {
            var options = (function() {
                if (state === null) {
                    return [];
                }

                var group = state ? 'good' : 'bad';

                return monthlyInspectionResponses[group].filter(function(item) {
                    if ('filter' in item) {
                        return item.filter.indexOf(type) !== -1;
                    }

                    return true;
                });
            })();

            return '<option value="">- Choose response -</option>' + $.map(options, function(option) {
                var message = option.message.replace(/{type}/, typeName);
                var $option = $('<option/>')
                    .val(message)
                    .text(message)
                    .attr('data-notes-required', 'notes_required' in option && option.notes_required);

                return $option[0].outerHTML;
            }).join('');
        }

        // Create canned responses
        $('.js-mir-checklist-met [name$="[notes]"]').each(function() {
            var type = $(this).attr('name').match(/(.*)\[notes\]$/)[1];
            $(this)
                .before($('<select/>')
                    .attr('class', 'mb-10 js-mir-checklist-canned-response')
                    .attr('data-type', type)
                    .prop('disabled', true)
                )
                .before($(this).clone()
                    .attr('name', false)
                    .attr('class', 'js-mir-checklist-additional-notes')
                    .attr('data-type', type)
                    .prop('disabled', true)
                )
                .hide();
        });

        // React to radio changes
        $('.js-mir-checklist').on('change', 'input[type="radio"][name$="[condition]"]', function(e) {
            var $item = $(this).closest('.js-mir-checklist-item');
            var state = $(this).val() == 1 ? true : ($(this).val() == 0 ? false : null);
            var type = $(this).attr('name').match(/(.*)\[condition\]$/)[1];
            var typeName = $('.js-mir-checklist-name', $item).text();

            $('[name="' + type + '[notes]"]', $item)
                .prop('required', state === false)
                .attr('placeholder', state === false ? 'Please fill out notes and upload photo' : '')
                .siblings('textarea.js-mir-checklist-additional-notes')
                .attr('placeholder', state === false ? 'Please fill out additional notes (if any) and upload photo' : '');

            $('[name="' + type + '[files]"]', $item)
                .prop('disabled', state !== false);

            $('[name="' + type + '[ticket_type]"]', $item)
                .prop('disabled', state !== false)
                .prop('required', state === false);

            $('select.js-mir-checklist-canned-response[data-type="' + type + '"]', $item)
                .prop('disabled', state === null)
                .prop('required', state !== null)
                .each(function() {
                    $(this).html(createOptions(state, type, typeName));
                });
        });

        // React to notes changes
        $('.js-mir-checklist-met').on(
            'change',
            'select.js-mir-checklist-canned-response, textarea.js-mir-checklist-additional-notes',
            function(e) {
                var $item = $(this).closest('.js-mir-checklist-item');
                var $selectedResponse = $item
                    .find('select.js-mir-checklist-canned-response option:selected');
                var type = $(this).data('type');
                var $elements = $(this).siblings().add(this);
                var text = $.trim([
                    $selectedResponse.val(),
                    $item.find('textarea.js-mir-checklist-additional-notes').val()
                ].join(' '));

                // Fill the proper notes field with computed text
                $('[name="' + type + '[notes]"]', $item)
                    .val(text)
                    .siblings('textarea.js-mir-checklist-additional-notes')
                    .prop('required', $selectedResponse.data('notes-required'))
                    .prop('disabled', text.length <= 0)
            }
        );

        // Initialize all checked radios
        $('.js-mir-checklist input[type="radio"][name$="[condition]"]:checked').trigger('change');

        // Initialize notes with matching canned response
        $('.js-mir-checklist-met [name$="[notes]"]').each(function() {
            var $options = $(this)
                .siblings('select.js-mir-checklist-canned-response')
                .children('option');
            var $additionalNote = $(this)
                .siblings('textarea.js-mir-checklist-additional-notes');
            var noteText = $(this).val();

            for (var i = 0, l = $options.length; i < l; i++) {
                var $option = $($options.get(i));
                var cannedText = $option.val();
                if (cannedText.length > 0 && noteText.substr(0, cannedText.length) === cannedText) {
                    // We have found matching option, select and finish
                    $options.prop('selected', false);
                    $option.prop('selected', true);
                    $additionalNote.val(noteText.substr(cannedText.length + 1));
                    return;
                }
            }
        });

        // Initialize all additional select notes
        $('.js-mir-checklist select.js-mir-checklist-canned-response').trigger('change');
    });
}();
